import { render } from "./CautionModal.vue?vue&type=template&id=c3e96040"
const script = {}

import "./CautionModal.vue?vue&type=style&index=0&id=c3e96040&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__